import { render } from "./DashBoardView.vue?vue&type=template&id=421c8d16"
import script from "./DashBoardView.vue?vue&type=script&lang=js"
export * from "./DashBoardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__